<template>
  <div>
    <p
      v-if="globalError.length > 0"
      class="mt-2 text-center text-red-500"
      v-html="globalError"
    />
    <form @submit.prevent="submitForm">
      <div class="relative mt-4">
        <FullNameField
          ref="fullName"
          v-model="signUpData.full_name"
          class="w-full field"
          label="Full name"
          :error="errors.full_name || ''"
        />
      </div>
      <div class="relative mt-4 sm:mt-8">
        <EmailField
          ref="email"
          v-model="signUpData.email"
          class="w-full field"
          label="Email"
          :error="errors.email || ''"
        />
      </div>
      <div class="relative mt-4 sm:mt-8">
        <PasswordField
          ref="password"
          v-model="signUpData.password"
          class="w-full field"
          label="Password"
          :error="errors.password || ''"
        />
      </div>
      <div
        class="text-center mt-5 sm:mt-10"
      >
        <div
          class="text-gray-600 text-sm text-b50 mt-10"
        >
          No credit card required
        </div>
        <div
          class="text-center mt-5 md:mt-5"
        >
          <LoaderButton
            v-event-track:signupButtonClicked
            :disabled="disableSubmitBtn"
            :is-loading="submitting"
          >
            Sign Up Free
          </LoaderButton>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import EmailField from '@/components/Fields/email.vue';
import FullNameField from '@/components/Fields/fullname.vue';
import PasswordField from '@/components/Fields/password.vue';

// mixins
import FullNameFieldValidation from '@/mixins/form-validation/FullNameFieldValidation.vue';
import EmailFieldValidation from '@/mixins/form-validation/EmailFieldValidation.vue';
import PasswordFieldValidation from '@/mixins/form-validation/PasswordFieldValidation.vue';
import LoaderButton from '../LoaderButton.vue';

export default {
  components: {
    FullNameField,
    EmailField,
    PasswordField,
    LoaderButton,
  },
  mixins: [
    FullNameFieldValidation,
    EmailFieldValidation,
    PasswordFieldValidation,
  ],
  props: {
    globalError: {
      type: String,
      default: '',
    },
    submitForm: {
      type: Function,
      default: () => {},
    },
    disableSubmitBtn: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    responseErrors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      signUpData: {
        full_name: '',
        email: '',
        password: '',
      },
      errors: {},
      lastValidationStatus: null,
    };
  },
  computed: {
    signInRedirect() {
      return this.$store.state.signInRedirect;
    },
    // TODO: remove after code refactoring
    showFullnameField() {
      return true;
    },
    isFormValid() {
      const hasFullName = this.$refs.fullName.validate;
      const hasEmail = this.$refs.email.validate;
      const hasPassword = this.$refs.password.validate;

      return hasFullName && hasEmail && hasPassword;
    },
  },
  watch: {
    signUpData: {
      handler() {
        this.emitValidateStatus();
      },
      deep: true,
    },
    'signUpData.full_name': function () {
      this.validateFullName();
    },
    'signUpData.email': function () {
      this.validateEmail();
    },
    'signUpData.password': function () {
      this.validatePassword();
    },
    responseErrors: {
      handler() {
        this.errors = {}; // Somehow if we don't set it as empty, vue doesn't watch the change
        if (typeof this.responseErrors !== 'undefined') {
          Object.keys(this.responseErrors).forEach((key) => {
            // eslint-disable-next-line prefer-destructuring
            this.errors[key] = this.responseErrors[key][0];
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    validateForm() {
      this.errors = {};

      this.validateFullName();
      this.validateEmail();
      this.validatePassword();
      this.emitValidateStatus();
    },
    emitValidateStatus() {
      this.$nextTick(() => {
        if (this.lastValidationStatus !== this.isFormValid) {
          this.lastValidationStatus = this.isFormValid;
          this.$emit('validated', this.isFormValid);
        }
      });
    },
  },
};
</script>
